import Token from '@/utils/Token';

/**
 * Kanban de contratos (T5.2/T5.4/T5.5).
 *
 * `listar` sem parâmetro monta o board inteiro; com `etapa` monta uma coluna só
 * — é o caminho do infinite scroll e da troca de ordenação. O cursor é cifrado
 * e carrega a ordenação dentro dele: ao paginar, `ordenar_por`/`direcao` são
 * ignorados pelo backend de propósito, então quem troca a ordenação recomeça a
 * coluna sem cursor.
 */
export default {
    listar(params = '') {
        if (params) params = `?${params}`;
        return axios.get(`/api/contrato/kanban${params}`, Token.getHeader());
    },
    preferencia() {
        return axios.get('/api/contrato/preferencia-visualizacao', Token.getHeader());
    },
    salvarPreferencia(params) {
        return axios.put('/api/contrato/preferencia-visualizacao', params, Token.getHeader());
    },
};
